import {
  BarChart2, LineChart, TrendingUp, TrendingDown, PieChart,
  Package, ShoppingCart, ShoppingBag, Store, Tag, Truck,
  DollarSign, Wallet, CreditCard, Banknote,
  Star, Bookmark, Heart, Flag, Pin,
  Layers, LayoutGrid, LayoutTemplate, Table, List,
  Settings, Search, Filter, Eye,
  Box, Archive, Warehouse, PaintBucket,
  Users, User, Bell, Calendar, Clock,
  Zap, Target, Award, Trophy, Thermometer,
  Folder, FileText, Shirt, Sparkles, Boxes,
  Percent, Hash, CircleDot,
  Megaphone, FlaskConical, Home,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const LUCIDE_ICONS: { name: string; component: LucideIcon }[] = [
  { name: "Home",         component: Home },
  { name: "BarChart2",    component: BarChart2 },
  { name: "LineChart",    component: LineChart },
  { name: "TrendingUp",   component: TrendingUp },
  { name: "TrendingDown", component: TrendingDown },
  { name: "PieChart",     component: PieChart },
  { name: "Package",      component: Package },
  { name: "ShoppingCart", component: ShoppingCart },
  { name: "ShoppingBag",  component: ShoppingBag },
  { name: "Store",        component: Store },
  { name: "Tag",          component: Tag },
  { name: "Truck",        component: Truck },
  { name: "DollarSign",   component: DollarSign },
  { name: "Wallet",       component: Wallet },
  { name: "CreditCard",   component: CreditCard },
  { name: "Banknote",     component: Banknote },
  { name: "Star",         component: Star },
  { name: "Bookmark",     component: Bookmark },
  { name: "Heart",        component: Heart },
  { name: "Flag",         component: Flag },
  { name: "Pin",          component: Pin },
  { name: "Layers",       component: Layers },
  { name: "LayoutGrid",   component: LayoutGrid },
  { name: "LayoutTemplate", component: LayoutTemplate },
  { name: "Table",        component: Table },
  { name: "List",         component: List },
  { name: "Settings",     component: Settings },
  { name: "Search",       component: Search },
  { name: "Filter",       component: Filter },
  { name: "Eye",          component: Eye },
  { name: "Box",          component: Box },
  { name: "Archive",      component: Archive },
  { name: "Warehouse",    component: Warehouse },
  { name: "PaintBucket",  component: PaintBucket },
  { name: "Boxes",        component: Boxes },
  { name: "Users",        component: Users },
  { name: "User",         component: User },
  { name: "Bell",         component: Bell },
  { name: "Calendar",     component: Calendar },
  { name: "Clock",        component: Clock },
  { name: "Zap",          component: Zap },
  { name: "Thermometer",  component: Thermometer },
  { name: "Target",       component: Target },
  { name: "Award",        component: Award },
  { name: "Trophy",       component: Trophy },
  { name: "Folder",       component: Folder },
  { name: "FileText",     component: FileText },
  { name: "Shirt",        component: Shirt },
  { name: "Sparkles",     component: Sparkles },
  { name: "Percent",      component: Percent },
  { name: "Hash",         component: Hash },
  { name: "CircleDot",    component: CircleDot },
  { name: "Megaphone",    component: Megaphone },
  { name: "FlaskConical", component: FlaskConical },
];

const LUCIDE_MAP = Object.fromEntries(LUCIDE_ICONS.map(i => [i.name, i.component]));

export function isLucideIcon(icon: string) {
  return icon.startsWith("lucide:");
}

export function getLucideName(icon: string) {
  return icon.slice(7); // убираем "lucide:"
}

interface ViewIconProps {
  icon: string;
  size?: number;
  className?: string;
}

export default function ViewIcon({ icon, size = 14, className = "" }: ViewIconProps) {
  if (isLucideIcon(icon)) {
    const name = getLucideName(icon);
    const Comp = LUCIDE_MAP[name];
    if (!Comp) return null;
    return (
      <span className={`flex items-center justify-center shrink-0 ${className}`} style={{ width: size, height: size }}>
        <Comp size={size} />
      </span>
    );
  }
  return (
    <span className={`flex items-center justify-center shrink-0 leading-none ${className}`} style={{ width: size, height: size, fontSize: size }}>
      {icon}
    </span>
  );
}
